const topicOptions = {
   company: [
      "Acoustica Audio",
      "Acustica Audio",
      "Ampeg",
      "Analog Obsession",
      "Antares",
      "Arturia",
      "Audiomodern",
      "beatMaker",
      "Bettermaker",
      "Black Box Analog Design",
      "Black Rooster Audio",
      "Bleass",
      "Brainworx",
      "Caelum Audio",
      "Celemony",
      "Cherry Audio",
      "Credland Audio",
      "Ctrlr",
      "Cymatics",
      "DecentSamples",
      "Devious Machines",
      "Dexed",
      "Diginoiz",
      "Dreamtonics",
      "DS Audio",
      "Electronik Sound Lab",
      "elysia",
      "emvoice",
      "Eplex7",
      "Evabeat",
      "Eventide",
      "Excite Audio",
      "FabFilter",
      "Fabric 70",
      "FeelYourSound",
      "Fuse Audio",
      "Future Audio Workshop",
      "Gforce",
      "GlitchMachines",
      "Higher HZ",
      "Hofa",
      "Hornet Plugins",
      "Ik Multimedia",
      "Inear Display",
      "Infinit Audio",
      "Initial Audio",
      "Izotope",
      "Karanyi Sounds",
      "Kilohearts",
      "Klanghelm",
      "Lindell Audio",
      "Liquidsonics",
      "Loopcloud",
      "Lunacy Audio",
      "Maag",
      "Mastering The Mix",
      "Matthew Lane",
      "MAudio",
      "MeldaProduction",
      "Mntra",
      "Momo",
      "Monoplugs",
      "Moog",
      "Mucoder",
      "Native Instruments",
      "Neold",
      "New Nation Audio",
      "oeksound",
      "OMG Instruments",
      "Pentacom",
      "Plugin Alliance‍",
      "Presonus",
      "Process Audio",
      "PSP",
      "Psp Audioware",
      "Pulsar Audio",
      "Pyrit Music",
      "Roman Kubiak",
      "Sample Science",
      "Scaler Music",
      "Schoeps",
      "SIR Audio Tools",
      "Softube",
      "Sonarworks",
      "Sonible",
      "Sonnox",
      "SoundSpot",
      "Soundtheory",
      "Soundtoys",
      "Spitfire Audio",
      "Ssl",
      "SSL",
      "Surge",
      "Tal",
      "Thenatan",
      "Tokyo Dawn Records",
      "Tritik",
      "U-he",
      "Ujam",
      "Unfiltered Audio",
      "UnitedPlugins",
      "Universal Audio",
      "Uvi",
      "Valhalla",
      "Vengeance Sound",
      "Vertigo Sound",
      "Vital Audio",
      "Voxengo",
      "Waves",
      "Wedge Force",
      "XLN Audio"
   ],
   functions: [
      "SPACER-Category ~ Category",
      "Category ~ Audio Effects",
      "Category ~ Synth or Sampler",
      "Category ~ Instrument General",
      "Category ~ Instrument Percussion",
      "Category ~ Instrument Piano or Organ",
      "Category ~ Instrument Orchestra",
      "Category ~ Instrument Guitar or Bass",
      "Category ~ Instrument Vocal",
      "Category ~ Music Generator",
      "Category ~ Arpeggiator or MIDI Effects",
      "Category ~ MIDI Controller",
      "Category ~ Loop library",
      "Category ~ AI Tool",
      "Category ~ General Production Tool",

      "SPACER-FrequencyControl ~ Frequency Control",
      "Frequency Control ~ EQ",
      "Frequency Control ~ Filter",

      "SPACER-Dynamics ~ Dynamics",
      "Dynamics ~ Compressor",
      "Dynamics ~ Multi-band Comp",
      "Dynamics ~ Limiter",
      "Dynamics ~ Clipper",
      "Dynamics ~ Transient Designer",
      "Dynamics ~ Gate or Expander",
      "Dynamics ~ De-Esser",
      "Dynamics ~ Gain or Volume Control",

      "SPACER-Saturation ~ Saturation",
      "Saturation ~ Distortion",
      "Saturation ~ Harmonics",
      "Saturation ~ Subharmonics",
      "Saturation ~ Exciter",

      "SPACER-TimeandSpace ~ Time and Space",
      "Time and Space ~ Reverb",
      "Time and Space ~ Delay",
      "Time and Space ~ Stereo Mono and Mid-Side Control",

      "SPACER-Modulation ~ Modulation",
      "Modulation ~ Chorus-Flanger-Phaser-Tremolo",
      "Modulation ~ Pitch-Shifter",
      "Modulation ~ Glitch or Granular",
      "Modulation ~ General Modulation",
      "Modulation ~ Phase Correction",
      "Modulation ~ Speed or Tempo Control",

      "SPACER-Simulation ~ Simulation",
      "Simulation ~ Room Sim",
      "Simulation ~ Cabinet Sim",
      "Simulation ~ Mic Sim",
      "Simulation ~ Amp Sim",
      "Simulation ~ Preamp Sim",

      "SPACER-CombinationTools ~ Combination Tools",
      "Combination Tools ~ Channel Strip",
      "Combination Tools ~ Effects Rack",
      "Combination Tools ~ Tone or Spectral Shaper",
      "Combination Tools ~ Vocal-Specific Processing",

      "SPACER-Analyzers ~ Analyzers",
      "Analyzers ~ Meter",
      "Analyzers ~ Loudness",
      "Analyzers ~ Spectrum",
      "Analyzers ~ Spatial",
      "Analyzers ~ Tuner",
      "Analyzers ~ Plugin Analysis",

      "SPACER-User Added ~ User Added"
   ],
   precision: ["Vibey Analog", "Analog Mastering", "Digital Precision"],
   color: [
      "Vintage ('60's & Earlier)",
      "70's",
      "80's",
      "Modern",
      "Extreme",
      "Dark Atmosphere",
      "Light Atmosphere",
      "Tribal & Earthy",
      "Asian",
      "European",
      "Latin",
      "Sci-Fi"
   ],
   status: ["Active", "Demo", "Disabled", "Wanted"]
};

export default topicOptions;
